module.exports = __webpack_public_path__ + "static/media/credit_card.b230472a.png";